import React, { useState, useEffect } from 'react';
import { calculateCost } from '../utils/calculateCost';
import { Link } from 'react-router-dom';
import './Homepage.css';
import { ReactComponent as CogIcon } from '../assets/cog.svg';
import { ReactComponent as TrashIcon } from '../assets/trash.svg';

const Homepage: React.FC = () => {
  const [isCounting, setIsCounting] = useState(false);
  const [cost, setCost] = useState(0);
  const [duration, setDuration] = useState(0);
  const [attendants, setAttendants] = useState<{ name: string; ral: number }[]>([]);
  const [title, setTitle] = useState<string>('');

  useEffect(() => {
    const savedAttendants = JSON.parse(localStorage.getItem('attendants') || '[]');
    setAttendants(savedAttendants);
    const savedTitle = localStorage.getItem('title') || '';
    setTitle(savedTitle);
    const savedDuration = parseInt(localStorage.getItem('duration') || '0');
    setDuration(savedDuration);
    setCost(calculateCost(savedAttendants, savedDuration));
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (isCounting) {
      interval = setInterval(() => {
        setDuration((prevDuration) => prevDuration + 1);
        setCost(calculateCost(attendants, duration + 1));
        localStorage.setItem('duration', duration.toString());
      }, 1000);
    } else if (!isCounting && duration !== 0 && interval) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isCounting, duration, attendants]);

  const handleStartPause = () => {
    setIsCounting(!isCounting);
  };

  const handleClear = () => {
    setIsCounting(false);
    setDuration(0);
    setCost(0);
    localStorage.setItem('duration', '0');
  };

  const formatDuration = (seconds: number) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}h ${mins}m ${secs}s`;
  };

  return (
    <div className={isCounting ? 'homepage started' : cost > 0 ? 'homepage paused' : 'homepage'}>
      <h1>RiunionEURO</h1>
      <div>
        <h2>{title}</h2>
        <p>{
          attendants.length === 0
            ? 'Nessun partecipante'
            : attendants.length === 1
            ? '1 partecipante'
            : `${attendants.length} partecipanti`
        }</p>
        <p className='attendants'>
          {attendants.map((attendant, index) => (
            <span key={index}>
              {attendant.name}
            </span>
          ))}
        </p>
        <button className="count-button" onClick={handleStartPause}>
          {isCounting ? `€ ${cost}` : cost > 0 ? 'Riprendi' : 'Inizia'}
        </button>
        <h3>Tempo trascorso: {formatDuration(duration)}</h3>
      </div>
      <Link to="/admin" className="admin-link">
        <CogIcon />
      </Link>
      <button onClick={handleClear} className="clear-button">
        <TrashIcon />
      </button>
    </div>
  );
};

export default Homepage;
